import axios from "axios";
import { attachDevLogging } from "./http.ts";

const baseURL = process.env.REACT_APP_IMAGE_SERVER_URL;

if (!baseURL) {
  throw new Error("Missing env: REACT_APP_IMAGE_SERVER_URL");
}

export const imageHttp = axios.create({
  baseURL,
  timeout: 30_000,
});

attachDevLogging(imageHttp, 'IMAGE_HTTP');
